<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@switch (definition?.subType) {
  @case ('chart') {
    <ng-container [ngTemplateOutlet]="chartTemplate"></ng-container>
  }
  @case ('csv') {
    <ng-container [ngTemplateOutlet]="csvTemplate"></ng-container>
  }
  @default {
    <ng-container [ngTemplateOutlet]="defaultTemplate"></ng-container>
  }
}


<ng-template #chartTemplate>
  <div class="report-container dash-gis-data-report-container" fxFill>
    <div class="chart-template" fxLayout="column" fxLayoutAlign="start stretch" fxFill>
      @if (showControls) {
        <dash-gis-report-controls
        [definition]="definition"></dash-gis-report-controls>
      }
      <div fxLayout="column" fxFlex="1 1 100%">
        <dash-gis-report-content-container [definition]="definition" fxLayout="column" fxFill
        (recordCount)="setRecordCount($event)"></dash-gis-report-content-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #csvTemplate>
  <div class="report-container dash-gis-data-report-container" fxFill>
    <dash-gis-report-content-container [definition]="definition"></dash-gis-report-content-container>
  </div>
</ng-template>

<ng-template #defaultTemplate>
  <div class="report-container dash-gis-data-report-container" fxLayout="column">
    <div class="non-chart-template" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="1 1 auto">
      @if (showControls) {
        <dash-gis-report-controls
        [definition]="definition"></dash-gis-report-controls>
      }
      <dash-gis-report-content-container [definition]="definition"
        (recordCount)="setRecordCount($event)"
      fxFlex="1 1 auto" fxLayout="column"></dash-gis-report-content-container>
    </div>
  </div>
</ng-template>

